import { ConfigurationDto201 } from '../configurationDto';
import { ConfigurationModel201 } from '../configurationModel';

export const configurationNormalizer201 = (
  configuration: ConfigurationDto201
): ConfigurationModel201 => {
  return configuration;
};
